module.exports = __webpack_public_path__ + "static/img/prepare_widget_3.41c690f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/prepare_widget_3.png
// module id = Lj+v
// module chunks = 11